//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, {useState} from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import TreeView from "eai-configurator-ui/components/base/TreeView";
import CustomizeColumnsDialog from "src/components/loader/dialog/CustomizeColumnsDialog";
import * as Utils from "eai-configurator-ui/components/Utils";

const ModuleTreeView = ({path, showCheckBoxes = true, editableOnly = false}) => {
  const [editableModules, setEditableModules] = useState(null);
  const [editableModuleNames, setEditableModuleNames] = useState(null);
  const [editedModuleName, setEditedModuleName] = useState(null);

  React.useEffect(() => {
    fetchEditableModules();
  }, []);

  const fetchEditableModules = () => {
    Utils.fetchData("loader/columnCustomizableModules")
      .then((customizableModules) => {
        if (customizableModules) {
          setEditableModules(customizableModules);
          setEditableModuleNames(new Set(customizableModules.map(module => module.moduleName)));
        }
      })
      .catch((response) => {
        // Ignore the error and clear editable modules
        console.log(response);
        setEditableModules(null);
      });
  };

  return (
    <div>
      <CustomizeColumnsDialog
        modules={editableModules}
        moduleName={editedModuleName}
        open={Boolean(editedModuleName)}
        handleClose={() => setEditedModuleName(null)}
        path={"loader:extract"}
      />
      <TreeView
        path={`${path}`}
        url={"loader/modulesTree?editableOnly=" + editableOnly}
        handleEdit={setEditedModuleName}
        editableNodeIdSet={editableModuleNames}
        showCheckBoxes={showCheckBoxes}
      />
    </div>
  );
};
export default ModuleTreeView;
